export const updateXY = (state) => {
    const { translateX, translateY } = state;
    let x = 0;
    let y = 0;

    if(translateX <= 0) x = translateX;
    if(translateX <= -1*(window.innerWidth - 340)) x = -1*(window.innerWidth - 340);

    if(translateY <= 0) y = translateY;
    if(translateY <= -1*(window.innerHeight - 260)) y = -1*(window.innerHeight - 260);
    return {x, y};
}

export function hoverOnVolumePanel(){
    const hoverdVolumePanel = document.getElementsByClassName("vjs-volume-panel vjs-control vjs-volume-panel-vertical vjs-slider-active");
    return hoverdVolumePanel.length > 0;
}

function displayCCHelper(player, language = ""){
    const enableCC = localStorage.getItem('closedCaption') !== "false";
    if(enableCC){
        let tracks = player.textTracks();
        if(tracks.length > 1){
            for(let i = 0; i < tracks.length; i++){
                if(tracks[i].kind === 'captions' && tracks[i].language === language){
                    tracks[i].mode = 'showing';
                }
            }
        } else if(tracks.length === 1 && (tracks[0].kind === 'captions' || tracks[0].kind === 'subtitles')){
            tracks[0].mode = 'showing';
        }
    }
}

// display caption after 3 seconds/
export const displayCC = (player, repeat = false, language = "") => {
    if(repeat){
        setTimeout(()=>displayCCHelper(player, language), 3000)
    } else {
        player.on('loadeddata', (e)=>{
            displayCCHelper(player, language)
        })
    }
    }